import { CircularProgress, styled } from "@mui/material";
import type { ComponentPropsWithRef } from "react";

import { Row } from "../layout";

export const Spinner = styled(CircularProgress)(({ theme }) => ({
  "& .MuiCircularProgress-svg": {
    color: theme.palette.grey[700],
  },
}));

interface SizedBoxProps extends ComponentPropsWithRef<typeof Row> {
  size: number | string;
}

export const SizedBox = styled(Row, {
  shouldForwardProp: (propName: keyof SizedBoxProps) => propName !== "size",
})<SizedBoxProps>(({ size }) => ({
  justifyContent: "center",
  overflow: "hidden",
  height: size,
  width: size,
}));
